import "./namespace.js";
import "../../components/form_data_uploader.js";

window.Sparkle ??= {};
window.Sparkle.PatientJourneyManager ??= {};
window.Sparkle.PatientJourneyManager.PatientDocuments ??= {};

Sparkle.PatientJourneyManager.PatientDocuments.Uploader = class Uploader extends Sparkle.FormDataUploader {
  constructor() {
    super(...arguments);
    this.upload = this.upload.bind(this);
  }

  upload(form) {
    form = jQuery(form);
    const formData = new FormData(form[0]);
    return super.upload(form.attr("action"), formData);
  }
};
